import React from 'react';
import AttributesInterface from 'interfaces/attributes.interface';

import './product-attributes-list.scss';
import classNames from 'classnames';

interface ProductAttributesProps {
    slice?: number;
    attributes: AttributesInterface[];
    showSeparator?: boolean;
}

const ProductAttributesList: React.FC<ProductAttributesProps> = ({ slice, attributes, showSeparator = true }) => {
    return (
        <ul className="product-attributes">
            {attributes.filter(attr => attr.label !== '').slice(0, slice || 3).map(attr => (
                <li className={classNames({
                    'product-attributes__item': true,
                    'product-attributes__item--visible-separator': showSeparator
                })} key={attr.label}
                >
                    <span>
                        {attr.label}
                        :&nbsp;
                    </span>
                    {attr.value}
                </li>
            ))}
        </ul>
    );
};

export default ProductAttributesList;
